<template>
  <el-container class="page">
    <el-header>
      <aui-header :currentUser="currentUser"></aui-header>
    </el-header>
    <el-container class="container">
      <el-aside v-show="isShowMenu" :width="isCollapse ? '64px' : '200px'" style="background: #3D3D3D;">
        <el-menu :router="true" :default-active="$route.path" :collapse="isCollapse" :collapse-transition="false" :unique-opened="true" active-text-color="#409EFF">
          <el-sub-menu v-for="item in menus" :key="item.index" :index="item.index">
            <template #title>
              <component class="icon" :is="item.icon"></component>
              <span>{{item.name}}</span>
            </template>
            <el-menu-item v-for="subItem in item.children" :key="subItem.index" :index="subItem.index" @click="menuHandler">
              <el-icon><caret-right></caret-right></el-icon>
              <template #title>{{subItem.name}}</template>
            </el-menu-item>
          </el-sub-menu>
        </el-menu>
      </el-aside>
      <el-main style="border: solid 1px #e6e6e6;">
        <div class="breadcrumb_container">
          <el-icon v-if="isPc && !isCollapse" @click="isCollapse = true"><fold /></el-icon>
          <el-icon v-if="isPc && isCollapse" @click="isCollapse = false"><expand /></el-icon>
          <el-icon v-if="!isPc" @click="isShowMenu = true"><expand /></el-icon>
          <el-breadcrumb separator=">">
            <el-breadcrumb-item v-for="(item, index) in currentMenus" :key="index">{{item}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <router-view :currentUser="currentUser"/>
      </el-main>
      <div class="mobile_modal" v-show="!isPc && isShowMenu" @click="isShowMenu = false"></div>
    </el-container>
    <!--
    <el-footer>
      <aui-footer></aui-footer>
    </el-footer>
    -->
  </el-container>
</template>

<script>
import auiHeader from '../components/aui-header'
import auiFooter from '../components/aui-footer'

export default {
  name: "home",
  components: { auiHeader, auiFooter },
  data() {
    return {
      isPc: true,
      currentUser: null,
      currentMenus: [],
      isShowMenu: true,
      isCollapse: false,
      menus: []
    }
  },
  methods: {
    getBreadcrumb() {
      const path = this.$route.path
      this.currentMenus = []
      const pIndex = this.menus.findIndex(item => path.startsWith(item.index))
      if (pIndex >= 0) {
        const pMenu = this.menus[pIndex]
        this.currentMenus.push(pMenu.name)
        const index = pMenu.children.findIndex(sub => sub.index === path)
        this.currentMenus.push(pMenu.children[index].name)
      }
    },
    resizeHandler() {
      if (!this.isPc) {
        this.isShowMenu = false
        this.isCollapse = false
      } else {
        this.isShowMenu = true
        this.isCollapse = false
      }
    },
    menuHandler() {
      if (!this.isPc) {
        this.isShowMenu = false
      }
    },
    showNotice() {
      this.$notify({
        title: '新功能上线啦！！！',
        message: '<div>1. 小程序下单支持扫描车架号查询油品套餐；</div><div>2. 系统管理->帮助中心，视频教程，一学就会。</div><div>麻溜的去体验吧......</div>',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
        duration: 15000
      })
      setTimeout(() => {
        this.$notify({
          title: '你可能还不知道？！！',
          message: '<div>1. 门店绑定的微信打开小程序可以核销订单了；</div><div>2. 有延保的订单需要提交延保申请资料才能生效。</div>',
          position: 'bottom-right',
          dangerouslyUseHTMLString: true,
          duration: 15000
        })
      }, 1500)
    }
  },
  created() {
    // 展示通知
    // this.showNotice()

    this.currentUser = this.$utils.getStorageObj('currentUser') ? this.$utils.getStorageObj('currentUser') : {}
    this.menus = this.$permission.generateMenu(this.currentUser.type)
    if (this.$route.path === '/index') {
      this.$router.push(this.menus[0].children[0].index)
    }
    this.getBreadcrumb()

    this.isPc = document.body.clientWidth > 500
    this.resizeHandler()
    let _that = this
    window.onresize = () => {
      window.screenWidth = document.body.clientWidth
      _that.isPc = window.screenWidth > 500
      console.log('resize', _that.isPc)
    }
  },
  watch: {
    $route(to, from) {
      this.getBreadcrumb()
    },
    isPc: {
      immediate: true,
      handler: function () {
        this.resizeHandler()
      }
    }
  }
}
</script>

<style>
.el-sub-menu {
  background: #3D3D3D;
  border-bottom: 1px solid #000000;
}
.el-sub-menu .el-sub-menu__title {
  color: #FFFFFF;
}
.el-sub-menu .el-menu-item {
  padding: 0;
  background: #313131;
  color: #FFFFFF;
}
.el-sub-menu.is-active, .el-sub-menu.is-active .el-sub-menu__title, .el-sub-menu .el-sub-menu__title:hover {
  background: #ff9148;
  color: #000000;
}
.el-sub-menu .el-menu-item.is-active, .el-sub-menu .el-menu-item:hover {
  color: #ff9148;
}
.breadcrumb_container {
  height: 32px;
  line-height: 32px;
  text-align: left;
}
.breadcrumb_container .el-icon {
  cursor: pointer;
}
.breadcrumb_container .el-breadcrumb {
  margin-left: 6px;
  display: inline-block;
}
.icon {
  margin-right: 3px;
  width: 22px;
}
.el-table--small {
  font-size: 13px;
}
.el-table__cell .el-link {
  margin-right: 12px;
}
.el-table__cell img {
  max-width: 32px;
  max-height: 32px;
}
.el-form-item .el-form-item__content {
  text-align: left;
}
.el-checkbox-group {
  margin-left: 30px;
  display: inline-block;
  height: 32px;
}
.el-input-group--append .el-input__inner {
  padding: 0 6px;
  text-align: center;
}
.el-input-group--append .el-input-group__append {
  padding: 0 6px;
}
.tips {
  text-align: left;
  font-size: 13px;
  color: #bebebf;
}
.pre_class {
  white-space: pre-wrap;
  white-space: -moz-pre-wrap;
  white-space: -o-pre-wrap;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
.dialog_width_large {
  width: 60%;
}
.dialog_width_small {
  width: 30%;
}
.image_uploader {
  width: 210px;
  height: 140px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.uploader_icon {
  font-size: 28px;
  color: #8c939d;
  width: 210px;
  height: 140px;
  text-align: center;
}
.uploader_icon svg {
  margin-top: 55px; /* (140px - 28px) / 2 - 1px */
}
.image_uploader img, .image_uploader video {
  width: 210px;
  height: 140px;
  display: block;
}
.video_container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 200;
}
.video_container .mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000;
  opacity: 0.7;
}
.video_container video {
  position:absolute;
  margin:auto;
  top:0;
  left:0;
  right:0;
  bottom:0;
  max-width: 100%;
  max-height: 100%;
}
.video_container .close_btn {
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 38px;
  color: #CDC9C9;
  cursor: pointer;
}
.color_normal {
  color: #409EFF;
}
.color_success {
  color: #67C23A;
}
.color_warning {
  color: #E6A23C;
}
.color_danger {
  color: #F56C6C;
}
.color_info {
  color: #909399;
}
.cursor_pointer {
  cursor: pointer;
}


@media only screen and (max-width: 960px) {
  .dialog_width_large {
    width: 88%;
  }
  .dialog_width_small {
    width: 30%;
  }
}

@media only screen and (max-width: 600px) {
  .container .el-aside {
    position: fixed;
    z-index: 200;
  }
  .el-date-editor {
    --el-date-editor-monthrange-width: 240px;
    --el-date-editor-daterange-width: 240px;
    --el-date-editor-datetimerange-width: 240px;
  }
  .el-pagination__sizes {
    display: none !important;
  }
  .mobile_modal {
    position: fixed;
    width: 100%;
    height: 100%;
    background: #909399;
    opacity: 0.7;
    z-index: 100;
  }
  .dialog_width_large {
    width: 640px
  }
  .dialog_width_small {
    width: 320px;
  }
}
</style>
